export const recentPurchases = [
  { name: 'Laura G.', city: 'Bogotá', product: 'MegaPack Dopamina Cero', time: 'hace 2 minutos' },
  { name: 'Andrés M.', city: 'Medellín', product: 'MegaPack Dopamina Cero', time: 'hace 4 minutos' },
  { name: 'Paola R.', city: 'Cali', product: 'MegaPack Dopamina Cero', time: 'hace 6 minutos' },
  { name: 'Camilo T.', city: 'Barranquilla', product: 'MegaPack Dopamina Cero', time: 'hace 9 minutos' },
  { name: 'Natalia V.', city: 'Bucaramanga', product: 'MegaPack Dopamina Cero', time: 'hace 11 minutos' },
  { name: 'Felipe C.', city: 'Pereira', product: 'MegaPack Dopamina Cero', time: 'hace 14 minutos' },
  { name: 'Valentina S.', city: 'Cartagena', product: 'MegaPack Dopamina Cero', time: 'hace 17 minutos' },
  { name: 'Jorge H.', city: 'Manizales', product: 'MegaPack Dopamina Cero', time: 'hace 21 minutos' },
  { name: 'Diana P.', city: 'Ibagué', product: 'MegaPack Dopamina Cero', time: 'hace 25 minutos' },
  { name: 'Sebastián L.', city: 'Santa Marta', product: 'MegaPack Dopamina Cero', time: 'hace 28 minutos' },
];
